import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CaseAssessmentComponent } from './case-assessment/case-assessment.component';
import { AnalyticsRoutingModule } from './analytics-routing.module';
import { EmailThreadGroupingsComponent } from './email-thread-groupings/email-thread-groupings.component';
import { EmailThreadComponent } from './email-thread/email-thread.component';
import { HorizontalBarChartComponent } from './horizontal-bar-chart/horizontal-bar-chart.component';
import { VerticalBarChartComponent } from './vertical-bar-chart/vertical-bar-chart.component';
import { SearchReportsComponent } from './search-report/search-reports/search-reports.component';
import { SearchReportQueriesComponent } from './search-report/search-report-queries/search-report-queries.component';
import { AddReportQueryComponent } from './search-report/dialogs/add-report-query/add-report-query.component';
import { AutoRedactionComponent } from './auto-redaction/auto-redaction/auto-redaction.component';
import { AutoRedactionDetailsComponent } from './auto-redaction/auto-redaction-details/auto-redaction-details.component';
import { AddAutoRedactionRuleComponent } from './auto-redaction/dialogs/add-auto-redaction-rule/add-auto-redaction-rule.component';
import { CustodianDetailsComponent } from './custodians/custodian-details/custodian-details.component';
import { CustodianComponent } from './custodians/custodian/custodian.component';
import { CreateCustodianComponent } from './custodians/create-custodian/create-custodian.component';
import { FactsAndIssuesComponent } from './facts-and-issues/facts-and-issues.component';
import { SharedModule } from '../../shared.module';
import { CaseNotesComponent } from './case-notes/case-notes.component';
import { CaseNotesEditorComponent } from './case-notes/case-notes-editor/case-notes-editor.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CaseNotesListComponent } from './case-notes/case-notes-list/case-notes-list.component';
import { ModifyIssueDialogComponent } from './facts-and-issues/modify-issue-dialog/modify-issue-dialog.component';
import { FactsComponent } from './facts-and-issues/facts/facts.component';
import { FactEditComponent } from './facts-and-issues/fact-edit/fact-edit.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FactsTimelineComponent } from './facts-and-issues/facts-timeline/facts-timeline.component';
import { MatSliderModule } from '@angular/material/slider';
import { MaterialModule } from '../../core/material/material.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NearDupTextGroupingsComponent } from './near-dup-text-groupings/near-dup-text-groupings.component';
import { CaseAnalyticsComponent } from './case-analytics/case-analytics.component';
import { CaseAnalyticsUploadsComponent } from './case-analytics/items/case-analytics-uploads/case-analytics-uploads.component';
import { CaseAnalyticsItemComponent } from './case-analytics/items/case-analytics-item/case-analytics-item.component';
import { CaseAnalyticsProductionsComponent } from './case-analytics/items/case-analytics-productions/case-analytics-productions.component';
import { CaseAnalyticsReviewSetsComponent } from './case-analytics/items/case-analytics-review-sets/case-analytics-review-sets.component';
import { CaseAnalyticsCustodiansComponent } from './case-analytics/items/case-analytics-custodians/case-analytics-custodians.component';
import { CaseAnalyticsReviewDocumentsComponent } from './case-analytics/items/case-analytics-review-documents/case-analytics-review-documents.component';
import { CaseAnalyticsCollectionSummaryComponent } from './case-analytics/items/case-analytics-collection-summary/case-analytics-collection-summary.component';
import { BarChartSkeletonLoaderComponent } from './case-analytics/items/skeleton-loaders/bar-chart/bar-chart-skeleton-loader.component';
import { DoughnutSkeletonLoaderComponent } from './case-analytics/items/skeleton-loaders/doughnut/doughnut-skeleton-loader.component';

import { RouterModule } from '@angular/router';
import { BaseChartDirective, provideCharts, withDefaultRegisterables, ThemeService } from 'ng2-charts';

@NgModule({
    declarations: [
        CaseAssessmentComponent,
        EmailThreadGroupingsComponent,
        EmailThreadComponent,
        HorizontalBarChartComponent,
        VerticalBarChartComponent,
        SearchReportsComponent,
        SearchReportQueriesComponent,
        AddReportQueryComponent,
        AutoRedactionComponent,
        AutoRedactionDetailsComponent,
        AddAutoRedactionRuleComponent,
        CustodianDetailsComponent,
        CustodianComponent,
        CreateCustodianComponent,
        FactsAndIssuesComponent,
        ModifyIssueDialogComponent,
        FactsComponent,
        FactEditComponent,
        CaseNotesComponent,
        FactsTimelineComponent,
        CaseNotesEditorComponent,
        CaseNotesListComponent,
        NearDupTextGroupingsComponent,
        CaseAnalyticsComponent,
        CaseAnalyticsUploadsComponent,
        CaseAnalyticsItemComponent,
        CaseAnalyticsProductionsComponent,
        CaseAnalyticsReviewSetsComponent,
        CaseAnalyticsCustodiansComponent,
        CaseAnalyticsReviewDocumentsComponent,
        CaseAnalyticsCollectionSummaryComponent,
        BarChartSkeletonLoaderComponent,
        DoughnutSkeletonLoaderComponent
    ],
	imports: [
		CommonModule,
		NgxChartsModule,
		AnalyticsRoutingModule,
		MaterialModule,
		MatAutocompleteModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		MatDatepickerModule,
		MatTableModule,
		MatSortModule,
		MatSlideToggleModule,
		MatSliderModule,
		ScrollingModule,
        RouterModule,
        BaseChartDirective,
	],
    exports: [BaseChartDirective],
    providers: [provideCharts(withDefaultRegisterables()), ThemeService],
})
export class AnalyticsModule {
}
